import {
    Alert, Button, Card, CardActionArea, CardContent, Grid2, Typography,
    Modal, Box, Stack
} from '@mui/material';
import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux'
import { setCargaDatos } from '../../Redux/V2/ContratoRedux';
import { SortNumericDown } from 'react-bootstrap-icons';
import { base64ToBlob, downloadBlob } from "../../Utilities/Pdf";
import { styleModalValidaCausa } from '../styles/modal'
import { Download } from '@mui/icons-material';

const ShowInformation = ({ from }) => {
    const dispatch = useDispatch()

    const entrevista = useSelector((store) => store.contratoV2.Entrevista)
    const defendido = useSelector((store) => store.contratoV2.Defendido)
    const actualizacion = useSelector((store) => store.contratoV2.Actualizacion)

    const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
    const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
    const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);
    const contratoValidado = useSelector((store) => store.contratoV2.ContratoValidado);
    const contratoActualizacion = useSelector((store) => store.contratoV2.ContratoActualizacion);

    const [estado, setEstado] = useState(null)
    const [alertestado, setAlertEstado] = useState(null)
    const [buttonActualizacion, setbuttonActualizacion] = useState(null)
    const [autorizacion, setAutorizacion] = useState(null)
    const [validation, setValidation] = useState(null)
    const [showHa, setShowHa] = useState(false)
    const [disableDownload, setDisableDownload] = useState(false)



    useEffect(() => {
        setbuttonActualizacion(null)

        // cancelado
        if (contratoCancelado && contratoCancelado.cancelado) {
            setEstado("Contrato Cancelado.")
            setAlertEstado("warning")
        }
        // finiquitado
        else if (contratoFiniquitado && contratoFiniquitado.finiquitado) {
            setEstado("Contrato Finiquitado.")
            setAlertEstado("warning")
        }

        // Cambio Estrategia 
        else if (actualizacion && actualizacion.actualizacion && actualizacion.actualizacion.status == 1 && actualizacion.actualizacion.type == 2) {
            //<Button variant='contained' color='warning' sx={{margin: 3}} onClick={handleUpdated}>ejecutar cambio de estrategia</Button>
            setbuttonActualizacion(<Button variant='outlined' color='info' onClick={handleCancelUpdated}>Anular cambio de estrategia</Button>)
            setEstado("En Proceso de Cambio Estrategia...")
            setAlertEstado("info")
        }

        // PRoceso de actualizacion
        else if (actualizacion && actualizacion.actualizacion && actualizacion.actualizacion.status == 1) {
            setbuttonActualizacion(<Button variant='outlined' color='info' onClick={handleCancelUpdated}>Anular actualizacion</Button>)
            /*setbuttonActualizacion(<>
                <Button variant='contained' color='warning' sx={{margin: 3}} onClick={handleUpdated}>ejecutar actualizacion</Button>
                <Button variant='outlined' color='info' onClick={handleCancelUpdated}>Anular actualizacion</Button>
            </>)*/
            setEstado("En Proceso de Actualización...")
            setAlertEstado("info")
        }
        //validado
        else if (contratoValidado && contratoValidado.validado) {
            setEstado("Contrato Validado.")
            setAlertEstado("success")
        }

        // firmado   
        else if (contratoFirmado && contratoFirmado.firmado == true) {
            setEstado("Contrato Firmado.")
            setAlertEstado("success")
        }
        // en curso
        else if (contratoFirmado && contratoFirmado.firmado == false) {
            setEstado("Contrato Pendiente de firma.")
            setAlertEstado("info")
        }
        else {
            setEstado("Contrato en Curso..")
            setAlertEstado("warning")
        }

        if (actualizacion?.estados) {
            changeResultUpdate()
        }
    }, [actualizacion])


    useEffect(() => {
        if (actualizacion && actualizacion.actualizacion && actualizacion.actualizacion.status == 2) {
            var message = actualizacion.actualizacion.type == 1 ? "Actualizacion Completada" : "Cambio de estrategia Completado"
            setAutorizacion({ message, status: "success" })

            var validate = actualizacion.actualizacion.validation;
            if (validate != true && actualizacion.actualizacion.type == 2 ) {
                var messageVal = "Validacion por cambio de estrategia pendiente"
                setValidation({ message: messageVal, status: "warning" })
            }else
                setValidation(null)
        }
        else if (contratoActualizacion?.doc?.length > 0 && actualizacion?.actualizacion?.status == 1) {
            const myLayout = contratoActualizacion.doc[0]
            console.log(myLayout.authorizationRequest)
            if (myLayout.authorizationRequest == 1) {//autorizacion solicitada
                var sinfirma = "";
                if (myLayout.noSignature == false) {
                    sinfirma = "Con firma";
                }
                else if (myLayout.noSignature == true) {
                    sinfirma = "Sin firma";
                }
                if (myLayout.authorize == null)
                    setAutorizacion({ message: "Autorizacion pendiente", status: "info" })
                else if (myLayout.authorize == false)
                    setAutorizacion({ message: "Autorizacion rechazada", status: "warning" })
                else if (myLayout.authorize == true)
                    setAutorizacion({ message: "Autorizacion aprobada " + sinfirma, status: "success" })
            } else {
                setAutorizacion(null)
            }
        } else {
            setAutorizacion(null)
        }
    }, [contratoActualizacion, actualizacion])

    useEffect(() => {
        if (contratoActualizacion.manualB64) {
            const blob = base64ToBlob(contratoActualizacion.manualB64, "application/pdf");
            downloadBlob(blob, "archivo.pdf");
        }
    }, [contratoActualizacion.manualB64])

    const changeResultUpdate = async () => {
        var estado = actualizacion?.estados;
        if (estado.defendido == 2) {
            await dispatch(setCargaDatos("Defendido", "get", entrevista.id));
        } if (estado.pagador == 2)
            await dispatch(setCargaDatos("Pagador", "get", entrevista.id))


        /*
            "cambioServicio": 0,
            "montoServicio": 0,
            "acreedores": 0,
            "cuotas": 0,
            "tareasCausa": 0,
            "causas": 0,
            "asignarCausaServicio": 0,
            "tareasSaC": 0,
            "tareasEpp": 0,
            "metodoPago": 0
        */

    }

    const handleUpdated = async () => {// ejecutar actualizacion o cambio de estrategia
        await dispatch(setCargaDatos("Actualizacion", "patch", { contractId: entrevista.contractId }))
    }

    const handleCancelUpdated = async () => {// ejecutar actualizacion o cambio de estrategia
        await dispatch(setCargaDatos("Actualizacion", "delete", { contractId: entrevista.contractId }))
    }

    const downloadDocument = async (typeDocument) => {
        setDisableDownload(true)
        var file = await dispatch(setCargaDatos("Download", "post", { typeDocument, contractId: entrevista.contractId, identifier: defendido.identifier }))
        if (file && file.document) {
            download(file)
        }
        setDisableDownload(false)
    }

    const download = (file) => {
        // limpiar base64 por si tiene espacios o saltos
        const cleanB64 = file.document.replace(/[\n\r\s]/g, "");

        // decodificar
        const byteCharacters = atob(cleanB64);
        const byteArray = new Uint8Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i);
        }

        // armar Blob
        const blob = new Blob([byteArray], { type: "application/pdf" });

        // bajar archivo
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = file.fileName || "documento.pdf";
        document.body.appendChild(link); // <-- MUY IMPORTANTE EN ALGUNOS NAVEGADORES
        link.click();
        link.remove();

        // limpiar memoria
        URL.revokeObjectURL(link.href);
    }

    return (
        <>
            <Card className='mb-2'>
                <CardContent>
                    <hr />
                    <Grid2 container sx={{ pl: 3, pr: 3, pt: 0 }}>
                        <Grid2 size={5}>
                            <tbody>
                                <tr>
                                    <th>Rut: </th>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}>{defendido.identifier ?? "no encontrado"}</td>
                                </tr>
                                <tr>
                                    <th>Nombre: </th>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}>{defendido.firstName ?? ""} {defendido.lastName ?? ""}</td>
                                </tr>
                                <tr>
                                    <th>Correo:</th>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}>{defendido.email ?? "no encontrado"}</td>
                                </tr>
                                <tr>
                                    <th>Teléfono: </th>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}>{defendido.telephone ?? "no encontrado"}</td>
                                </tr>
                                <tr>
                                    <th>Atendido Por: </th>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}>{entrevista?.atendidoPor ?? "no encontrado"}</td>
                                </tr>
                                <tr>
                                    <th>Linea de negocio: </th>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}>{entrevista?.lineaNegocio ?? "no encontrado"}</td>
                                </tr>
                                <tr>
                                    <th>Codigo de contrato: </th>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}>{entrevista?.codigoContrato ?? "no encontrado"}</td>
                                </tr>
                            </tbody>
                        </Grid2>
                        <Grid2 size={3} align={"left"} >

                            <tbody>
                                <tr>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}><Button onClick={() => setShowHa(!showHa)}>Hoja de atención</Button> <br /></td>
                                </tr>
                                <tr>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}><Button disabled={disableDownload} onClick={() => downloadDocument("ctto")}>Contrato <Download /></Button> <br /></td>
                                </tr>
                                {/*<tr>
                                    <td style={{ paddingLeft: '10px', paddingBottom: '5px' }}><Button onClick={() => setShowHa(!showHa)}>Otros documentos</Button> <br /></td>
                                </tr>
                                */}
                            </tbody>

                        </Grid2>

                        <Grid2 size={4} align="left">
                            <Stack spacing={1}>

                                {estado && (<Box pl={1}> <Alert severity={alertestado}> {estado} </Alert> </Box>)}

                                {autorizacion && (<Box pl={1}> <Alert severity={autorizacion.status} sx={{ whiteSpace: 'pre-line' }} > {autorizacion.message} </Alert> </Box>)}

                                {validation && (<Box pl={1}> <Alert severity={validation.status} sx={{ whiteSpace: 'pre-line' }} > {validation.message} </Alert> </Box>)}

                                {buttonActualizacion && (<Box mt={1}> {buttonActualizacion} </Box>)}

                            </Stack>
                        </Grid2>


                    </Grid2>
                </CardContent>

            </Card>

            <Modal
                open={showHa}
                onClose={() => setShowHa(!showHa)}
            >
                <Box sx={styleModalValidaCausa}>
                    <div style={{ background: "white", padding: "16px", borderRadius: "8px", width: "100%", margin: "auto" }}>
                        <Typography variant="h5" style={{ textAlign: 'center' }}>Hoja de atención</Typography>
                        <Button disabled={disableDownload} onClick={() => downloadDocument("ha")}>Descargar <Download /></Button>
                        <Typography
                            className='p-5'
                            component="div"
                            dangerouslySetInnerHTML={{ __html: entrevista.hojaAtencion ?? "" }}
                        />
                    </div>
                </Box>

            </Modal>
        </>
    );
};

export default ShowInformation;